import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import styled from "styled-components";

export default function Thanks() {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  // si pas connecté, retour home (sécurité)
  useEffect(() => {
    if (!isAuthenticated) navigate("/", { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <Wrap>
      <Card>
        <Title>Application bientôt disponible sur iOS et Android !</Title>
        <Desc>
          Merci pour votre soutien 🙏<br />
          Nous vous tiendrons informé(e) de l’évolution.<br />
          Pour tout feedback, écrivez-nous via la page <b>Contact</b>.
        </Desc>

        <Actions>
          <Btn onClick={() => navigate("/contact")}>Donner un feedback</Btn>
          <Ghost onClick={() => navigate("/")}>Retour à l’accueil</Ghost>
        </Actions>
      </Card>
    </Wrap>
  );
}

const Wrap = styled.div`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: #0b0f14;
`;

const Card = styled.div`
  width: min(520px, 100%);
  padding: 22px 20px;
  border-radius: 18px;

  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  color: rgba(255, 255, 255, 0.92);
  text-align: center;
`;

const Title = styled.h1`
  margin: 0 0 12px 0;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.2px;
`;

const Desc = styled.p`
  margin: 0 0 16px 0;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.78);
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 10px;
`;

const Btn = styled.button`
  height: 46px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(0, 103, 114, 0.92);
  color: #fff;
  font-weight: 900;
  cursor: pointer;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.35);

  &:hover {
    background: rgba(255, 255, 255, 0.92);
    color: #0b0f14;
  }
`;

const Ghost = styled.button`
  height: 46px;
  padding: 0 18px;
  border-radius: 999px;
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.18);
  font-weight: 900;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;